<template lang="pug">
    div
        h5._300.m-b-md.m-t-md Confirm each modifier attribute is matched to the correct column in your import file :

        form(id="import-mapper")
            div.row-col.m-b-md
                div.col-xs-6.dark.p-a-md
                    span._500.m-l-sm Core Modifier Attributes
                div.col-xs-6.dark.p-a-md
                    span._500.m-l-sm Colums in Your Document 

            div.row-col.m-b-md(v-for="attribute in attributes")
                div.col-xs-6.b-a.p-a-sm.p-l-md.dker
                    span.clear._500 {{ attribute.name }}
                    span.text-danger(v-if="attribute.required") *
                
                div.col-xs-6.b-a.p-a-sm
                    div.form-group(:class="{ 'has-error': errors[attribute.key] }")
                        select.form-control(
                            :disabled="onLoading(loader)"
                            :required="attribute.required",
                            v-model="attribute.mapper",
                            @change="clearError(attribute.key)"
                        )
                            option(v-bind:value="null") None
                            option(v-for="heading in headings" v-bind:value="heading") {{ toTitleCase(heading) }}

                        p.text-danger.m-t-xs.m-b-0(v-if="errors[attribute.key]")
                            small {{ errors[attribute.key] }}

                        ul.m-t-sm.m-l-sm.list-unstyled.text-muted(v-if="getSampleDataByKey(attribute.mapper).length")
                            li(v-for="data in getSampleDataByKey(attribute.mapper)") {{ data }}
</template>

<script>
import { Event } from '../../../event-bus';

export default {
    props: {
        uploadedContent: {
            type: Object,
            required: true,
        },
        importKey: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            errors: {},
            attributes: [
                {
                    key: 'modifier_key',
                    name: 'Modifier Key',
                    mapper: null,
                    required: false,
                },
                {
                    key: 'set_name',
                    autoKey: 'modifier_set_name',
                    name: 'Modifier Set Name',
                    mapper: null,
                    required: true,
                },
                {
                    key: 'min_apply_limit',
                    name: 'Min Apply Limit',
                    mapper: null,
                    required: false,
                },
                {
                    key: 'max_apply_limit',
                    name: 'Max Apply Limit',
                    mapper: null,
                    required: false,
                },
                {
                    key: 'modifier_name',
                    name: 'Modifier Name',
                    mapper: null,
                    required: true,
                },
                { key: 'mode', name: 'Mode', mapper: null, required: true },
                { key: 'amount', name: 'Amount', mapper: null, required: true },
                {
                    key: 'preselect',
                    name: 'Preselect',
                    mapper: null,
                    required: false,
                },
            ],
        };
    },

    computed: {
        headings() {
            return this.uploadedContent.headings.filter(h => {
                return typeof h == 'string';
            });
        },

        rows() {
            return this.uploadedContent.rows;
        },

        mapper() {
            let mapper = {};

            this.attributes.forEach(attribute => {
                mapper[attribute.key] = attribute.mapper;
            });

            return mapper;
        },
        loader() {
            return 'importing modifier';
        },
    },

    mounted() {
        this.autoMappingColumn();
    },

    methods: {
        autoMappingColumn() {
            this.attributes.forEach((attr, idx) => {
                const detectKey = attr.autoKey || attr.key;
                if (this.isHeadingsExists(detectKey)) {
                    attr.mapper = detectKey;
                }
            });
        },

        isHeadingsExists(heading) {
            return !_.isUndefined(this.headings.find(h => h == heading));
        },

        /**
         * @param  {String} key
         * @return {Array}
         */
        getSampleDataByKey(key) {
            if (_.isNull(key)) {
                return [];
            }

            return this.rows
                .filter(row => {
                    return !_.isNull(row[key]) && row[key] != '';
                })
                .map(row => row[key])
                .splice(0, 3);
        },

        clearError(key) {
            this.$delete(this.errors, key);
        },

        validateRequiredFields() {
            this.errors = {};
            this.attributes.filter(attr => attr.required).forEach(attr => {
                if (!attr.mapper) {
                    this.$set(
                        this.errors,
                        attr.key,
                        `"${
                            attr.name
                        }" column is required. Please select the matching column.`,
                    );
                }
            });
            return Object.keys(this.errors).length === 0;
        },

        submit() {
            if (!this.validateRequiredFields()) {
                return;
            }

            this.startLoading(this.loader);

            let api = Laroute.route(
                'franchise.inventory.modifier.validate_data',
                {
                    importKey: this.importKey,
                },
            );

            axios
                .post(api, this.mapper)
                .then(res => {
                    Event.$emit('validating-data', this.mapper);
                })
                .catch(err => {
                    this.endLoading(this.loader);
                    if (err.response && err.response.status === 422) {
                        const apiErrors = err.response.data.errors || {};
                        Object.keys(apiErrors).forEach(field => {
                            this.$set(this.errors, field, apiErrors[field][0]);
                        });
                    } else {
                        this.showApiError(err);
                    }
                });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/modifier/import-modifier-mapper.vue